// Textos de la zona "admin". Claves con prefijo "admin.".
// Panel de control (pages/AdminPanel.js). Las claves admin.act.* son las
// acciones de la bitácora (backend/app/services/audit.py → ACCIONES).

const en = {
  'admin.title': 'Control panel',
  'admin.subtitle': 'Accounts, activity and storage of DragonAudio',
  'admin.backToPlayer': 'Back to player',
  'admin.tab.resumen': 'Overview',
  'admin.tab.usuarios': 'Users',
  'admin.tab.almacenamiento': 'Storage',
  'admin.tab.bitacora': 'Audit log',
  'admin.tab.bloqueos': 'Locks',
  'admin.loading': 'Loading…',
  'admin.refresh': 'Refresh',
  'admin.close': 'Close',
  'admin.never': 'never',
  'admin.you': 'you',
  'admin.page': 'Page {page} of {total}',
  'admin.confirm.sure': 'Are you sure?',
  'admin.confirm.yes': 'Yes',
  'admin.confirm.no': 'No',
  'admin.noApi': 'The server is not passing /admin to the API (it returned the web page). On the server, add “handle /admin/*” to the Caddyfile and reload Caddy.',
  'admin.crash': 'This tab failed to display.',
  'admin.retry': 'Reload',

  'admin.stats.users': 'Users',
  'admin.stats.usersNote': '{admins} admin · {off} disabled',
  'admin.stats.active24': 'Active today',
  'admin.stats.activeNote': '{d7} in 7 days · {d30} in 30',
  'admin.stats.new7': 'New this week',
  'admin.stats.newNote': '{h24} today · {d30} in 30 days',
  'admin.stats.logins24': 'Logins (24 h)',
  'admin.stats.loginsNote': '{n} failed',
  'admin.stats.fuxi24': 'Fuxi messages (24 h)',
  'admin.stats.fuxiNote': '{d7} in 7 days',
  'admin.stats.audios': 'Saved audios',
  'admin.stats.security24': 'Security · last 24 hours',
  'admin.chart.logins': 'People who logged in, per day',
  'admin.chart.signups': 'Sign-ups per day',
  'admin.chart.total14': '{n} in 14 days',

  'admin.users.search': 'Search by email or name…',
  'admin.users.allRoles': 'All roles',
  'admin.users.allStates': 'All states',
  'admin.users.sortNew': 'Newest first',
  'admin.users.sortSeen': 'Last seen',
  'admin.users.sortEmail': 'Email A–Z',
  'admin.users.count': '{n} accounts',
  'admin.role.admin': 'Admin',
  'admin.role.user': 'User',
  'admin.state.active': 'Active',
  'admin.state.disabled': 'Disabled',
  'admin.state.disabledSince': 'Disabled · {date}',
  'admin.col.account': 'Account',
  'admin.col.role': 'Role',
  'admin.col.lastSeen': 'Last seen',
  'admin.col.lastLogin': 'Last login',
  'admin.col.created': 'Created',
  'admin.col.when': 'When',
  'admin.col.action': 'Action',
  'admin.col.who': 'Who',
  'admin.col.target': 'On',
  'admin.col.detail': 'Detail',

  'admin.user.listener': 'Listener type',
  'admin.user.usage': 'Usage',
  'admin.user.recordings': 'Recordings',
  'admin.user.tracks': 'Tracks',
  'admin.user.configs': 'Setups',
  'admin.user.tests': 'Hearing tests',
  'admin.user.fuxi': 'Fuxi messages',
  'admin.user.chats': '{n} chats',
  'admin.user.actions': 'Actions',
  'admin.user.selfNote': 'This is your account. To change your password or email use “My profile”.',
  'admin.user.activity': 'Recent activity',
  'admin.action.promote': 'Make admin',
  'admin.action.demote': 'Remove admin',
  'admin.action.resetLink': 'Generate password link',
  'admin.action.revoke': 'Sign out everywhere',
  'admin.action.disable': 'Disable account',
  'admin.action.enable': 'Re-enable account',
  'admin.action.reason': 'Reason (stays in the audit log)',
  'admin.done.promoted': 'Now this account is an admin.',
  'admin.done.demoted': 'This account is no longer an admin.',
  'admin.done.revoked': 'All its sessions were closed.',
  'admin.done.disabled': 'Account disabled. Its sessions were closed.',
  'admin.done.enabled': 'Account re-enabled.',
  'admin.reset.title': 'Link to create a new password',
  'admin.reset.hint': 'Send it to the user through a private channel (WhatsApp, in person). Valid for {h} hours and only once. You never see their password.',
  'admin.reset.copy': 'Copy',
  'admin.reset.copied': 'Copied',
  'admin.reset.warning': 'Whoever has this link can take the account. It is shown only now.',

  'admin.storage.disk': 'Server disk',
  'admin.storage.diskNote': '{used} of {total} used · {free} free',
  'admin.storage.db': 'Database: {size}',
  'admin.storage.recordings': 'Recordings (Recorder)',
  'admin.storage.tracks': 'Tracks (Audio player)',
  'admin.storage.expiringRec': 'Deleted within 12 h',
  'admin.storage.expiringTracks': 'Deleted within 3 days',
  'admin.storage.limitFiles': 'Max files per user',
  'admin.storage.limitUser': 'Quota per user',
  'admin.storage.limitFile': 'Max per file',
  'admin.storage.content': 'Saved content',
  'admin.storage.chats': 'Fuxi chats',
  'admin.storage.messages': 'Fuxi messages (both sides)',
  'admin.storage.auditRows': 'Audit log entries',
  'admin.storage.top': 'Who uses the most space',
  'admin.storage.topEmpty': 'Nobody has saved audios.',
  'admin.storage.topNote': '{rec} rec · {tr} tracks',

  'admin.audit.all': 'All actions',
  'admin.audit.group.auth': 'Login and sign-up (all)',
  'admin.audit.group.account': 'Profile changes (all)',
  'admin.audit.group.admin': 'Admin actions (all)',
  'admin.audit.email': 'Email…',
  'admin.audit.count': '{n} entries',
  'admin.audit.empty': 'Nothing recorded yet.',

  'admin.locks.title': 'Locked right now',
  'admin.locks.hint': 'Too many failed attempts lock an email or IP for a while. Lift it if it is someone legitimate. A server restart clears them all.',
  'admin.locks.empty': 'Nobody is locked.',
  'admin.locks.login': 'Login (by email)',
  'admin.locks.login_ip': 'Login (by IP)',
  'admin.locks.registro': 'Sign-up (by IP)',
  'admin.locks.recuperacion': 'Password recovery (by email)',
  'admin.locks.asistente': 'Fuxi (by user id)',
  'admin.locks.left': '{min} min left',
  'admin.locks.clear': 'Lift',

  'admin.act.auth.register': 'Signed up',
  'admin.act.auth.register_existing': 'Sign-up with an existing email',
  'admin.act.auth.login_ok': 'Logged in',
  'admin.act.auth.login_fail': 'Failed login',
  'admin.act.auth.login_blocked': 'Login blocked (too many attempts)',
  'admin.act.auth.login_disabled': 'Login to a disabled account',
  'admin.act.auth.reset_requested': 'Asked for password recovery',
  'admin.act.auth.reset_done': 'Created a new password',
  'admin.act.account.password_changed': 'Changed password',
  'admin.act.account.email_change_requested': 'Asked to change email',
  'admin.act.account.email_changed': 'Changed email',
  'admin.act.admin.role_changed': 'Role changed',
  'admin.act.admin.user_disabled': 'Account disabled',
  'admin.act.admin.user_enabled': 'Account re-enabled',
  'admin.act.admin.sessions_revoked': 'Sessions closed by admin',
  'admin.act.admin.reset_link': 'Password link generated by admin',
  'admin.act.admin.lock_cleared': 'Lock lifted',
  'admin.act.admin.user_edited': 'Account data corrected',
  'admin.act.admin.note_added': 'Internal note added',
  'admin.act.admin.note_deleted': 'Internal note deleted',
  'admin.act.admin.tags_changed': 'Tags changed',
  'admin.act.admin.limits_changed': 'Custom quota',
  'admin.act.admin.files_purged': 'Saved audios deleted by admin',
  'admin.act.admin.user_exported': 'Account data exported',
  'admin.act.admin.users_exported': 'User list exported (CSV)',
  'admin.act.admin.bulk': 'Bulk action',
  'admin.act.admin.announcement': 'Announcement changed',
  'admin.act.admin.user_anonymized': 'Data deleted (anonymized)',
  'admin.done.anonymized': 'Account anonymized. Its personal data no longer exists.',
  'admin.anon.button': 'Delete their data (habeas data)',
  'admin.anon.title': 'Anonymize this account — it cannot be undone',
  'admin.anon.what': 'Email, name, phone, setups, hearing tests, Fuxi chats, audios, notes and tags are deleted, and their email, IP and browser are erased from the audit log. The account stays disabled with no way to identify anyone: the usage statistics keep working.',
  'admin.anon.tip': 'If the person also asked for a copy, “Export their data” FIRST. Law 1581: answer within 15 business days.',
  'admin.anon.reason': 'Request reference (e.g. email of 23 Oct)',
  'admin.anon.type': 'To confirm, type {email}',
  'admin.anon.typeLabel': 'Account email, to confirm',
  'admin.anon.do': 'Anonymize forever',
  'admin.anon.already': 'This account was anonymized: it no longer holds personal data.',

  'admin.tab.crecimiento': 'Growth',
  'admin.tab.servidor': 'Server',
  'admin.tab.seguridad': 'Security',
  'admin.tab.avisos': 'Announcements',
  'admin.dur.dh': '{d} d {h} h',
  'admin.dur.hm': '{h} h {m} min',
  'admin.dur.m': '{m} min',
  'admin.feature.visita': 'Visits',
  'admin.feature.config': 'Saved setups',
  'admin.feature.test': 'Hearing test',
  'admin.feature.grabacion': 'Recorder',
  'admin.feature.pista': 'Uploaded tracks',
  'admin.feature.fuxi': 'Fuxi',

  // Users (list, bulk, card)
  'admin.users.anyActivity': 'Any activity',
  'admin.users.act.hoy': 'Seen today',
  'admin.users.act.semana': 'Seen this week',
  'admin.users.act.inactivos': 'Inactive 30+ days',
  'admin.users.act.nunca': 'Never came back',
  'admin.users.allTags': 'All tags',
  'admin.users.csvHelp': 'Download this list (with its filters) as a spreadsheet. It is recorded in the audit log.',
  'admin.users.selectPage': 'Select the whole page',
  'admin.col.days30': 'Days (30)',
  'admin.col.days30Help': 'Days with activity in the last 30: who is a regular at a glance',
  'admin.bulk.selected': '{n} selected',
  'admin.bulk.tag_add': 'Add tag',
  'admin.bulk.tag_remove': 'Remove tag',
  'admin.bulk.revoke': 'Sign out everywhere',
  'admin.bulk.disable': 'Disable',
  'admin.bulk.enable': 'Re-enable',
  'admin.bulk.apply': 'Apply',
  'admin.bulk.clear': 'Clear selection',
  'admin.bulk.done': 'Done on {n} accounts.',
  'admin.bulk.skipped': '{n} skipped (your own account or the last admin).',
  'admin.tags.placeholder': 'tag (beta, vip…)',
  'admin.tags.add': '+ tag',
  'admin.tags.remove': 'Remove tag {tag}',
  'admin.edit.title': 'Correct name or email',
  'admin.edit.name': 'Name',
  'admin.edit.email': 'Email',
  'admin.edit.emailWarn': 'The email is the key to password recovery. Pending links to the old address stop working.',
  'admin.edit.save': 'Save',
  'admin.done.edited': 'Data corrected.',
  'admin.done.limits': 'Quota saved.',
  'admin.done.exported': 'Data downloaded (JSON).',
  'admin.done.purged': '{n} files deleted · {size} freed.',
  'admin.user.calendar': 'Days of use (17 weeks)',
  'admin.user.calendarNote': '{n} days with activity',
  'admin.user.featureDays': 'Days using:',
  'admin.user.devices': 'Devices and places it logged in from (90 days)',
  'admin.user.noDevices': 'No logins recorded.',
  'admin.user.deviceTimes': '{n}×',
  'admin.user.data': 'Personal data',
  'admin.action.export': 'Export their data',
  'admin.action.exportHelp': 'Everything the app keeps about this person in a JSON: the answer to a data access request (habeas data, Colombian Law 1581).',
  'admin.action.purge': 'Delete their {n} saved audios',
  'admin.notes.title': 'Internal notes',
  'admin.notes.placeholder': 'Only the team sees this (“asked for help with the EQ”, “possible spam”…)',
  'admin.notes.add': 'Note',
  'admin.notes.delete': 'delete',
  'admin.limits.title': 'Storage quota',
  'admin.limits.custom': 'custom',
  'admin.limits.summary': 'Recordings: {rf} files · {rb}. Tracks: {tf} files · {tb}.',
  'admin.limits.change': 'Change',
  'admin.limits.files': 'Files',
  'admin.limits.mb': 'MB',
  'admin.limits.hint': 'Empty = the default (shown in grey). Lowering it deletes nothing: it only blocks new uploads.',
  'admin.limits.reset': 'Back to default',

  // Growth
  'admin.growth.intro': 'How many use the app, how many come back and what they use. Hover any number for what it means.',
  'admin.growth.period': 'Period',
  'admin.growth.days': '{n} days',
  'admin.growth.dauHelp': 'Daily Active Users: different people who used the app today (UTC).',
  'admin.growth.dauNote': '{n} per day on average (7 d)',
  'admin.growth.wauHelp': 'Weekly Active Users: different people in the last 7 days.',
  'admin.growth.wauNote': 'last 7 days',
  'admin.growth.mauHelp': 'Monthly Active Users: different people in the last 30 days. The main growth number.',
  'admin.growth.mauNote': '30 days ago: {n}',
  'admin.growth.stickiness': 'Stickiness',
  'admin.growth.stickinessHelp': 'Average DAU ÷ MAU: what part of the month comes back each day. Facebook boasted ~50 %; for a tool used now and then, 10–20 % is normal.',
  'admin.growth.stickyHigh': 'A habit: they come almost every day',
  'admin.growth.stickyMid': 'Normal for an occasional tool',
  'admin.growth.stickyLow': 'They come and leave: work on coming back',
  'admin.growth.newUsers': 'Sign-ups ({n} d)',
  'admin.growth.newNote': 'previous period: {n}',
  'admin.growth.totalUsers': 'Total accounts',
  'admin.growth.activeChart': 'Active users (rolling)',
  'admin.growth.inPeriod': '{n} in the period',
  'admin.growth.totalChart': 'Accounts over time',
  'admin.growth.funnel': 'Activation funnel',
  'admin.growth.funnelHelp': 'Of the accounts created in the last {n} days: how far did each one get? The biggest drop is where to improve.',
  'admin.growth.f.registrados': 'Signed up',
  'admin.growth.f.registradosHelp': 'Created the account',
  'admin.growth.f.entraron': 'Used the app',
  'admin.growth.f.entraronHelp': 'At least one day with activity',
  'admin.growth.f.usaron': 'Used a feature',
  'admin.growth.f.usaronHelp': 'Saved a setup, did the test, recorded, uploaded a track or talked to Fuxi',
  'admin.growth.f.volvieron': 'Came back another day',
  'admin.growth.f.volvieronHelp': 'Active on 2 or more different days',
  'admin.growth.f.habito': 'Habit',
  'admin.growth.f.habitoHelp': 'Active on 5 or more different days',
  'admin.growth.adoption': 'Feature adoption',
  'admin.growth.adoptionHelp': 'Of the {n} active users in the last 30 days, how many used each feature. (Effects and the Studio live in the browser: not counted here yet.)',
  'admin.growth.cohorts': 'Weekly retention cohorts',
  'admin.growth.cohortsHelp': 'Each row = people who signed up that week. Week 0 = the week they signed up; week 2 = how many were still using the app two weeks later. Darker = better. The classic Amplitude/Mixpanel table.',
  'admin.growth.cohortWeek': 'Week of',
  'admin.growth.cohortUsers': 'People',
  'admin.growth.weekN': 'W{n}',
  'admin.growth.when': 'When the app is used',
  'admin.growth.heatNote': 'Logins of the last 30 days by weekday and hour (your local time). Good for choosing when to do maintenance.',
  'admin.growth.atRisk': 'At risk of leaving',
  'admin.growth.atRiskHelp': 'Active accounts that used to come and have been away 7–30 days. Ordered by how regular they were.',
  'admin.growth.atRiskNone': 'Nobody: everyone who came recently is still coming.',
  'admin.growth.atRiskRow': '{d} active days · seen {hace}',

  // Server
  'admin.server.intro': 'The machine, the API and the database, measured like Datadog or Grafana do (USE and RED methods). In memory: restarting the service resets the history.',
  'admin.server.live': 'Live (15 s)',
  'admin.server.health': 'Health checks',
  'admin.check.db': 'Database',
  'admin.check.db.help': 'PostgreSQL answers a SELECT 1. If it fails, nobody can log in.',
  'admin.check.db.ok': 'Answers in {ms} ms',
  'admin.check.db.mal': 'Not answering!',
  'admin.check.disco': 'Disk',
  'admin.check.disco.help': 'Below 2 GB free, no upload is accepted and PostgreSQL is at risk.',
  'admin.check.disco.ok': '{libre} free',
  'admin.check.disco.aviso': 'Only {libre} free: less than 10 %',
  'admin.check.disco.mal': 'Only {libre} free: uploads are blocked',
  'admin.check.swap': 'Swap',
  'admin.check.swap.help': 'With 1 GB of RAM, without swap the backend dies from lack of memory (DESPLIEGUE_AWS.md step 4.1).',
  'admin.check.swap.ok': '{total} active',
  'admin.check.swap.aviso': 'No swap! Make it permanent in /etc/fstab',
  'admin.check.ram': 'Memory',
  'admin.check.ram.help': 'RAM in use. Over 90 % the machine starts using swap and slows down.',
  'admin.check.ram.ok': '{pct} % in use',
  'admin.check.ram.aviso': '{pct} %: tight',
  'admin.check.ram.mal': '{pct} %: about to run out',
  'admin.check.cron_purga': 'Expired-audio sweep',
  'admin.check.cron_purga.help': 'The daily cron of purge_recordings.py (DESPLIEGUE_AWS.md step 11.2) deletes expired audios.',
  'admin.check.cron_purga.ok': 'Running',
  'admin.check.cron_purga.aviso': '{n} expired audios still there: is the cron running?',
  'admin.check.groq': 'Fuxi (Groq)',
  'admin.check.groq.help': 'Without GROQ_API_KEY, Fuxi answers with the local keyword fallback.',
  'admin.check.groq.ok': 'Key configured',
  'admin.check.groq.aviso': 'No key: local fallback only',
  'admin.check.correo': 'Email (Brevo)',
  'admin.check.correo.help': 'Without BREVO_API_KEY, password recovery emails are not sent.',
  'admin.check.correo.ok': 'Key configured',
  'admin.check.correo.aviso': 'No key: emails are not sent',
  'admin.check.monitor': 'Machine monitor',
  'admin.check.monitor.help': 'Needs the psutil package (requirements.txt).',
  'admin.check.monitor.ok': 'Measuring every minute',
  'admin.check.monitor.aviso': 'psutil missing: pip install -r requirements.txt',
  'admin.server.noPsutil': 'Machine data unavailable: install psutil on the server (pip install -r requirements.txt) and restart the service.',
  'admin.server.cpuHelp': 'Average CPU use in the last minute.',
  'admin.server.cpuNote': '{n} cores · load {carga}',
  'admin.server.steal': 'CPU steal',
  'admin.server.stealHelp': 'CPU time AWS takes away. On a t3 (burstable) instance, high steal = the CPU credits ran out and AWS is throttling the machine.',
  'admin.server.stealOk': 'Credits OK',
  'admin.server.stealBad': 'Out of CPU credits!',
  'admin.server.ramHelp': 'Memory in use (without the reclaimable cache).',
  'admin.server.swapHelp': 'Swap in use. Rising swap = RAM is not enough.',
  'admin.server.noSwap': 'no swap',
  'admin.server.diskFree': '{free} free',
  'admin.server.process': 'API process',
  'admin.server.processHelp': 'Memory used by uvicorn (the backend).',
  'admin.server.processNote': 'up {up} · {h} threads',
  'admin.server.machine24': 'Machine · last 24 h',
  'admin.server.warming': 'The machine chart fills in one point per minute: come back in a couple of minutes.',
  'admin.server.machineNote': '{so} · Python {py} · machine on for {up}',
  'admin.server.api': 'API',
  'admin.server.rpm': 'Requests / min',
  'admin.server.rpmHelp': 'Traffic (golden signal 1): average of the last hour.',
  'admin.server.rpmNote': '{h} in 1 h · {d} in 24 h',
  'admin.server.errors': 'Errors 5xx (1 h)',
  'admin.server.errorsHelp': 'Errors (golden signal 2): server failures. 4xx are user mistakes (wrong password, expired session) and are normal.',
  'admin.server.errorsNote': '24 h: {e5} errors 5xx · {e4} 4xx',
  'admin.server.p50Help': 'Latency (golden signal 3): half of the requests are faster than this.',
  'admin.server.p95Help': '95 % of the requests are faster than this. What the unlucky users feel. Above 1.5 s it shows.',
  'admin.server.p99Help': 'The slowest 1 %: spikes, cold starts, big uploads.',
  'admin.server.since': 'API measured for {up} (since the last restart).',
  'admin.server.trafficHour': 'Traffic · last hour',
  'admin.server.requests': 'Requests',
  'admin.server.latencyDay': 'Average latency · 24 h',
  'admin.server.avgMs': 'Average',
  'admin.server.routes': 'By route',
  'admin.server.routesHelp': 'Each API route with its requests, errors and latency (last 300 calls). The slowest is the first to optimize.',
  'admin.server.route': 'Route',
  'admin.server.max': 'Max',
  'admin.server.lastErrors': 'Latest 500 errors',
  'admin.server.journal': 'The full trace: sudo journalctl -u audio -n 100 --no-pager',
  'admin.pg.ping': 'Latency',
  'admin.pg.size': 'Size',
  'admin.pg.up': 'Running for',
  'admin.pg.connections': 'Connections',
  'admin.pg.cache': 'Cache hits',
  'admin.pg.tx': 'Commits / rollbacks',
  'admin.pg.deadlocks': 'Deadlocks',
  'admin.pg.tables': 'Biggest tables',
  'admin.pg.rows': '{n} rows',

  // Security
  'admin.sec.failed': 'Failed logins',
  'admin.sec.days7': 'last 7 days',
  'admin.sec.blocked': 'Locks',
  'admin.sec.disabledTries': 'Disabled-account tries',
  'admin.sec.resets': 'Recovery requests',
  'admin.sec.pwChanged': '{n} passwords changed',
  'admin.sec.adminActions': 'Admin actions',
  'admin.sec.chart24': 'Logins · last 24 h',
  'admin.sec.ips': 'IPs that fail the most (7 d)',
  'admin.sec.ipsHelp': 'One IP trying MANY different accounts = “password spraying”. Click to see its entries in the audit log.',
  'admin.sec.emails': 'Most attacked accounts (7 d)',
  'admin.sec.emailsHelp': 'One account tried from MANY IPs = “credential stuffing” (a password list stolen from another site).',
  'admin.sec.none': 'Nothing suspicious.',
  'admin.sec.tries': 'Tries',
  'admin.sec.accounts': 'Accounts',
  'admin.sec.last': 'Last',
  'admin.sec.spray': 'spraying',
  'admin.sec.sprayHelp': 'This IP tried 3 or more different accounts',
  'admin.sec.locks': '{n} locks',
  'admin.sec.ghost': 'does not exist',
  'admin.sec.stuffing': 'stuffing',
  'admin.sec.stuffingHelp': 'Tried from 3 or more different IPs',
  'admin.sec.newIp': 'Logins from a new IP (7 d)',
  'admin.sec.newIpHelp': 'Correct logins from an IP that account had not used in the previous 30 days (GitHub warns about this). Usually a new phone or network; if the person did not do it, sign out everywhere.',
  'admin.sec.admins': 'Admin access review',
  'admin.sec.adminsHelp': 'Who has the keys. Audits ask to review it periodically: an admin who no longer needs it should stop being one.',
  'admin.sec.adminRow': 'seen {hace} · {n} actions (30 d)',

  // Announcements
  'admin.ann.title': 'Announcement for everyone',
  'admin.ann.help': 'A banner at the bottom of every page, also on the login screen. For maintenance windows, news or incidents. Each user can close it; publishing a new one shows it again.',
  'admin.ann.showing': 'Showing now',
  'admin.ann.hidden': 'Not showing',
  'admin.ann.tone': 'Type',
  'admin.ann.tone.info': 'Information',
  'admin.ann.tone.aviso': 'Warning',
  'admin.ann.tone.mantenimiento': 'Maintenance',
  'admin.ann.textEs': 'Text in Spanish',
  'admin.ann.textEn': 'Text in English',
  'admin.ann.from': 'Show from (optional)',
  'admin.ann.until': 'Until (optional)',
  'admin.ann.datesHelp': 'In your local time. Without dates it shows until you remove it.',
  'admin.ann.publish': 'Publish',
  'admin.ann.remove': 'Remove',
  'admin.ann.live': 'Published: everyone sees it now.',
  'admin.ann.scheduled': 'Saved: it will show within its dates.',
  'admin.ann.off': 'Announcement removed.',
  'admin.ann.by': 'Last change: {who} · {when}',
  'admin.ann.preview': 'Preview',
  'admin.ann.previewHelp': 'This is how it looks (in the current language).',
  'admin.ann.empty': 'Write the text…',
  'admin.ann.close': 'Close the announcement',
};

const es = {
  'admin.title': 'Panel de control',
  'admin.subtitle': 'Cuentas, actividad y almacenamiento de DragonAudio',
  'admin.backToPlayer': 'Volver al reproductor',
  'admin.tab.resumen': 'Resumen',
  'admin.tab.usuarios': 'Usuarios',
  'admin.tab.almacenamiento': 'Almacenamiento',
  'admin.tab.bitacora': 'Bitácora',
  'admin.tab.bloqueos': 'Bloqueos',
  'admin.loading': 'Cargando…',
  'admin.refresh': 'Actualizar',
  'admin.close': 'Cerrar',
  'admin.never': 'nunca',
  'admin.you': 'tú',
  'admin.page': 'Página {page} de {total}',
  'admin.confirm.sure': '¿Seguro?',
  'admin.confirm.yes': 'Sí',
  'admin.confirm.no': 'No',
  'admin.noApi': 'El servidor no le pasa /admin a la API (devolvió la página web). En el servidor, añade «handle /admin/*» al Caddyfile y recarga Caddy.',
  'admin.crash': 'Esta pestaña no se pudo mostrar.',
  'admin.retry': 'Recargar',

  'admin.stats.users': 'Usuarios',
  'admin.stats.usersNote': '{admins} admin · {off} desactivados',
  'admin.stats.active24': 'Activos hoy',
  'admin.stats.activeNote': '{d7} en 7 días · {d30} en 30',
  'admin.stats.new7': 'Nuevos esta semana',
  'admin.stats.newNote': '{h24} hoy · {d30} en 30 días',
  'admin.stats.logins24': 'Entradas (24 h)',
  'admin.stats.loginsNote': '{n} fallidas',
  'admin.stats.fuxi24': 'Mensajes a Fuxi (24 h)',
  'admin.stats.fuxiNote': '{d7} en 7 días',
  'admin.stats.audios': 'Audios guardados',
  'admin.stats.security24': 'Seguridad · últimas 24 horas',
  'admin.chart.logins': 'Personas que entraron, por día',
  'admin.chart.signups': 'Registros por día',
  'admin.chart.total14': '{n} en 14 días',

  'admin.users.search': 'Buscar por correo o nombre…',
  'admin.users.allRoles': 'Todos los roles',
  'admin.users.allStates': 'Todos los estados',
  'admin.users.sortNew': 'Más recientes',
  'admin.users.sortSeen': 'Última vez visto',
  'admin.users.sortEmail': 'Correo A–Z',
  'admin.users.count': '{n} cuentas',
  'admin.role.admin': 'Admin',
  'admin.role.user': 'Usuario',
  'admin.state.active': 'Activa',
  'admin.state.disabled': 'Desactivada',
  'admin.state.disabledSince': 'Desactivada · {date}',
  'admin.col.account': 'Cuenta',
  'admin.col.role': 'Rol',
  'admin.col.lastSeen': 'Visto',
  'admin.col.lastLogin': 'Última entrada',
  'admin.col.created': 'Creada',
  'admin.col.when': 'Cuándo',
  'admin.col.action': 'Acción',
  'admin.col.who': 'Quién',
  'admin.col.target': 'Sobre',
  'admin.col.detail': 'Detalle',

  'admin.user.listener': 'Tipo de oyente',
  'admin.user.usage': 'Uso',
  'admin.user.recordings': 'Grabaciones',
  'admin.user.tracks': 'Pistas',
  'admin.user.configs': 'Setups',
  'admin.user.tests': 'Tests de oído',
  'admin.user.fuxi': 'Mensajes a Fuxi',
  'admin.user.chats': '{n} chats',
  'admin.user.actions': 'Acciones',
  'admin.user.selfNote': 'Es tu cuenta. Para tu contraseña o tu correo usa «Mi perfil».',
  'admin.user.activity': 'Actividad reciente',
  'admin.action.promote': 'Hacer admin',
  'admin.action.demote': 'Quitar admin',
  'admin.action.resetLink': 'Generar enlace de contraseña',
  'admin.action.revoke': 'Cerrar todas sus sesiones',
  'admin.action.disable': 'Desactivar cuenta',
  'admin.action.enable': 'Reactivar cuenta',
  'admin.action.reason': 'Motivo (queda en la bitácora)',
  'admin.done.promoted': 'Ahora esta cuenta es admin.',
  'admin.done.demoted': 'Esta cuenta ya no es admin.',
  'admin.done.revoked': 'Se cerraron todas sus sesiones.',
  'admin.done.disabled': 'Cuenta desactivada. Sus sesiones se cerraron.',
  'admin.done.enabled': 'Cuenta reactivada.',
  'admin.reset.title': 'Enlace para crear contraseña nueva',
  'admin.reset.hint': 'Pásaselo al usuario por un medio privado (WhatsApp, en persona). Vale {h} horas y una sola vez. Tú nunca ves su contraseña.',
  'admin.reset.copy': 'Copiar',
  'admin.reset.copied': 'Copiado',
  'admin.reset.warning': 'Quien tenga este enlace puede tomar la cuenta. Solo se muestra ahora.',

  'admin.storage.disk': 'Disco del servidor',
  'admin.storage.diskNote': '{used} de {total} usados · {free} libres',
  'admin.storage.db': 'Base de datos: {size}',
  'admin.storage.recordings': 'Grabaciones (Grabadora)',
  'admin.storage.tracks': 'Pistas (Reproductor de audios)',
  'admin.storage.expiringRec': 'Se borran en menos de 12 h',
  'admin.storage.expiringTracks': 'Se borran en menos de 3 días',
  'admin.storage.limitFiles': 'Máx. archivos por usuario',
  'admin.storage.limitUser': 'Cuota por usuario',
  'admin.storage.limitFile': 'Máx. por archivo',
  'admin.storage.content': 'Contenido guardado',
  'admin.storage.chats': 'Chats con Fuxi',
  'admin.storage.messages': 'Mensajes de Fuxi (ambos lados)',
  'admin.storage.auditRows': 'Registros de bitácora',
  'admin.storage.top': 'Quién ocupa más espacio',
  'admin.storage.topEmpty': 'Nadie tiene audios guardados.',
  'admin.storage.topNote': '{rec} grab · {tr} pistas',

  'admin.audit.all': 'Todas las acciones',
  'admin.audit.group.auth': 'Entrada y registro (todas)',
  'admin.audit.group.account': 'Cambios de perfil (todas)',
  'admin.audit.group.admin': 'Acciones de admin (todas)',
  'admin.audit.email': 'Correo…',
  'admin.audit.count': '{n} registros',
  'admin.audit.empty': 'Aún no hay nada registrado.',

  'admin.locks.title': 'Bloqueados ahora mismo',
  'admin.locks.hint': 'Demasiados intentos fallidos bloquean un correo o una IP un rato. Levántalo si es alguien legítimo. Reiniciar el servidor los borra todos.',
  'admin.locks.empty': 'Nadie está bloqueado.',
  'admin.locks.login': 'Entrada (por correo)',
  'admin.locks.login_ip': 'Entrada (por IP)',
  'admin.locks.registro': 'Registro (por IP)',
  'admin.locks.recuperacion': 'Recuperar contraseña (por correo)',
  'admin.locks.asistente': 'Fuxi (por id de usuario)',
  'admin.locks.left': 'quedan {min} min',
  'admin.locks.clear': 'Levantar',

  'admin.act.auth.register': 'Se registró',
  'admin.act.auth.register_existing': 'Registro con correo ya existente',
  'admin.act.auth.login_ok': 'Entró',
  'admin.act.auth.login_fail': 'Entrada fallida',
  'admin.act.auth.login_blocked': 'Entrada bloqueada (muchos intentos)',
  'admin.act.auth.login_disabled': 'Entrada a cuenta desactivada',
  'admin.act.auth.reset_requested': 'Pidió recuperar contraseña',
  'admin.act.auth.reset_done': 'Creó contraseña nueva',
  'admin.act.account.password_changed': 'Cambió la contraseña',
  'admin.act.account.email_change_requested': 'Pidió cambiar el correo',
  'admin.act.account.email_changed': 'Cambió el correo',
  'admin.act.admin.role_changed': 'Cambio de rol',
  'admin.act.admin.user_disabled': 'Cuenta desactivada',
  'admin.act.admin.user_enabled': 'Cuenta reactivada',
  'admin.act.admin.sessions_revoked': 'Sesiones cerradas por admin',
  'admin.act.admin.reset_link': 'Enlace de contraseña generado por admin',
  'admin.act.admin.lock_cleared': 'Bloqueo levantado',
  'admin.act.admin.user_edited': 'Datos de la cuenta corregidos',
  'admin.act.admin.note_added': 'Nota interna añadida',
  'admin.act.admin.note_deleted': 'Nota interna borrada',
  'admin.act.admin.tags_changed': 'Etiquetas cambiadas',
  'admin.act.admin.limits_changed': 'Cuota a la medida',
  'admin.act.admin.files_purged': 'Audios guardados borrados por admin',
  'admin.act.admin.user_exported': 'Datos de la cuenta exportados',
  'admin.act.admin.users_exported': 'Lista de usuarios exportada (CSV)',
  'admin.act.admin.bulk': 'Acción en lote',
  'admin.act.admin.announcement': 'Aviso general cambiado',
  'admin.act.admin.user_anonymized': 'Datos suprimidos (anonimizada)',
  'admin.done.anonymized': 'Cuenta anonimizada. Sus datos personales ya no existen.',
  'admin.anon.button': 'Suprimir sus datos (habeas data)',
  'admin.anon.title': 'Anonimizar esta cuenta — no se puede deshacer',
  'admin.anon.what': 'Se borran correo, nombre, teléfono, setups, tests de oído, chats con Fuxi, audios, notas y etiquetas, y en la bitácora se borran su correo, IP y navegador. La cuenta queda desactivada sin forma de saber de quién era: las estadísticas siguen cuadrando.',
  'admin.anon.tip': 'Si la persona también pidió una copia, «Exportar sus datos» ANTES. Ley 1581: responder en máximo 15 días hábiles.',
  'admin.anon.reason': 'Referencia de la solicitud (ej. correo del 23 oct)',
  'admin.anon.type': 'Para confirmar, escribe {email}',
  'admin.anon.typeLabel': 'Correo de la cuenta, para confirmar',
  'admin.anon.do': 'Anonimizar para siempre',
  'admin.anon.already': 'Esta cuenta fue anonimizada: ya no guarda datos personales.',

  'admin.tab.crecimiento': 'Crecimiento',
  'admin.tab.servidor': 'Servidor',
  'admin.tab.seguridad': 'Seguridad',
  'admin.tab.avisos': 'Avisos',
  'admin.dur.dh': '{d} d {h} h',
  'admin.dur.hm': '{h} h {m} min',
  'admin.dur.m': '{m} min',
  'admin.feature.visita': 'Visitas',
  'admin.feature.config': 'Setups guardados',
  'admin.feature.test': 'Test de oído',
  'admin.feature.grabacion': 'Grabadora',
  'admin.feature.pista': 'Pistas subidas',
  'admin.feature.fuxi': 'Fuxi',

  // Usuarios (lista, lote, ficha)
  'admin.users.anyActivity': 'Cualquier actividad',
  'admin.users.act.hoy': 'Vistos hoy',
  'admin.users.act.semana': 'Vistos esta semana',
  'admin.users.act.inactivos': 'Inactivos +30 días',
  'admin.users.act.nunca': 'Nunca volvieron',
  'admin.users.allTags': 'Todas las etiquetas',
  'admin.users.csvHelp': 'Descarga esta lista (con sus filtros) como hoja de cálculo. Queda en la bitácora.',
  'admin.users.selectPage': 'Seleccionar toda la página',
  'admin.col.days30': 'Días (30)',
  'admin.col.days30Help': 'Días con actividad en los últimos 30: quién es habitual de un vistazo',
  'admin.bulk.selected': '{n} seleccionadas',
  'admin.bulk.tag_add': 'Poner etiqueta',
  'admin.bulk.tag_remove': 'Quitar etiqueta',
  'admin.bulk.revoke': 'Cerrar sus sesiones',
  'admin.bulk.disable': 'Desactivar',
  'admin.bulk.enable': 'Reactivar',
  'admin.bulk.apply': 'Aplicar',
  'admin.bulk.clear': 'Quitar selección',
  'admin.bulk.done': 'Hecho en {n} cuentas.',
  'admin.bulk.skipped': '{n} saltadas (tu propia cuenta o el último admin).',
  'admin.tags.placeholder': 'etiqueta (beta, vip…)',
  'admin.tags.add': '+ etiqueta',
  'admin.tags.remove': 'Quitar la etiqueta {tag}',
  'admin.edit.title': 'Corregir nombre o correo',
  'admin.edit.name': 'Nombre',
  'admin.edit.email': 'Correo',
  'admin.edit.emailWarn': 'El correo es la llave para recuperar la contraseña. Los enlaces pendientes al correo viejo dejan de valer.',
  'admin.edit.save': 'Guardar',
  'admin.done.edited': 'Datos corregidos.',
  'admin.done.limits': 'Cuota guardada.',
  'admin.done.exported': 'Datos descargados (JSON).',
  'admin.done.purged': '{n} archivos borrados · {size} liberados.',
  'admin.user.calendar': 'Días de uso (17 semanas)',
  'admin.user.calendarNote': '{n} días con actividad',
  'admin.user.featureDays': 'Días usando:',
  'admin.user.devices': 'Equipos y lugares desde donde entró (90 días)',
  'admin.user.noDevices': 'Sin entradas registradas.',
  'admin.user.deviceTimes': '{n}×',
  'admin.user.data': 'Datos personales',
  'admin.action.export': 'Exportar sus datos',
  'admin.action.exportHelp': 'Todo lo que la app guarda de esta persona en un JSON: la respuesta a una consulta de habeas data (Ley 1581).',
  'admin.action.purge': 'Borrar sus {n} audios guardados',
  'admin.notes.title': 'Notas internas',
  'admin.notes.placeholder': 'Solo las ve el equipo («pidió ayuda con el EQ», «posible spam»…)',
  'admin.notes.add': 'Anotar',
  'admin.notes.delete': 'borrar',
  'admin.limits.title': 'Cuota de almacenamiento',
  'admin.limits.custom': 'a la medida',
  'admin.limits.summary': 'Grabaciones: {rf} archivos · {rb}. Pistas: {tf} archivos · {tb}.',
  'admin.limits.change': 'Cambiar',
  'admin.limits.files': 'Archivos',
  'admin.limits.mb': 'MB',
  'admin.limits.hint': 'Vacío = el de serie (en gris). Bajarla no borra nada: solo impide subir más.',
  'admin.limits.reset': 'Volver a la de serie',

  // Crecimiento
  'admin.growth.intro': 'Cuántos usan la app, cuántos vuelven y qué usan. Pasa el ratón por cualquier número para saber qué significa.',
  'admin.growth.period': 'Periodo',
  'admin.growth.days': '{n} días',
  'admin.growth.dauHelp': 'Usuarios activos diarios (DAU): personas distintas que usaron la app hoy (UTC).',
  'admin.growth.dauNote': '{n} al día en promedio (7 d)',
  'admin.growth.wauHelp': 'Usuarios activos semanales (WAU): personas distintas en los últimos 7 días.',
  'admin.growth.wauNote': 'últimos 7 días',
  'admin.growth.mauHelp': 'Usuarios activos mensuales (MAU): personas distintas en los últimos 30 días. El número principal de crecimiento.',
  'admin.growth.mauNote': 'hace 30 días: {n}',
  'admin.growth.stickiness': 'Stickiness',
  'admin.growth.stickinessHelp': 'DAU promedio ÷ MAU: qué parte del mes vuelve cada día. Facebook presumía ~50 %; en una herramienta de uso puntual, 10–20 % es normal.',
  'admin.growth.stickyHigh': 'Hábito: vienen casi a diario',
  'admin.growth.stickyMid': 'Normal para una herramienta puntual',
  'admin.growth.stickyLow': 'Vienen y se van: trabaja el regreso',
  'admin.growth.newUsers': 'Registros ({n} d)',
  'admin.growth.newNote': 'periodo anterior: {n}',
  'admin.growth.totalUsers': 'Cuentas en total',
  'admin.growth.activeChart': 'Usuarios activos (móviles)',
  'admin.growth.inPeriod': '{n} en el periodo',
  'admin.growth.totalChart': 'Cuentas a lo largo del tiempo',
  'admin.growth.funnel': 'Embudo de activación',
  'admin.growth.funnelHelp': 'De las cuentas creadas en los últimos {n} días: ¿hasta dónde llegó cada una? La caída más grande es dónde mejorar.',
  'admin.growth.f.registrados': 'Se registraron',
  'admin.growth.f.registradosHelp': 'Crearon la cuenta',
  'admin.growth.f.entraron': 'Usaron la app',
  'admin.growth.f.entraronHelp': 'Al menos un día con actividad',
  'admin.growth.f.usaron': 'Usaron una función',
  'admin.growth.f.usaronHelp': 'Guardaron un setup, hicieron el test, grabaron, subieron una pista o hablaron con Fuxi',
  'admin.growth.f.volvieron': 'Volvieron otro día',
  'admin.growth.f.volvieronHelp': 'Activos en 2 días distintos o más',
  'admin.growth.f.habito': 'Hábito',
  'admin.growth.f.habitoHelp': 'Activos en 5 días distintos o más',
  'admin.growth.adoption': 'Adopción de funciones',
  'admin.growth.adoptionHelp': 'De los {n} activos de los últimos 30 días, cuántos usaron cada función. (Los efectos y el Estudio viven en el navegador: aún no cuentan aquí.)',
  'admin.growth.cohorts': 'Cohortes semanales de retención',
  'admin.growth.cohortsHelp': 'Cada fila = quienes se registraron esa semana. Semana 0 = la semana del registro; semana 2 = cuántos seguían usando la app dos semanas después. Más oscuro = mejor. La tabla clásica de Amplitude/Mixpanel.',
  'admin.growth.cohortWeek': 'Semana del',
  'admin.growth.cohortUsers': 'Personas',
  'admin.growth.weekN': 'S{n}',
  'admin.growth.when': 'Cuándo se usa la app',
  'admin.growth.heatNote': 'Entradas de los últimos 30 días por día y hora (tu hora local). Sirve para elegir cuándo hacer mantenimiento.',
  'admin.growth.atRisk': 'En riesgo de irse',
  'admin.growth.atRiskHelp': 'Cuentas activas que venían y llevan 7–30 días sin aparecer. Ordenadas por lo habituales que eran.',
  'admin.growth.atRiskNone': 'Nadie: todos los que venían siguen viniendo.',
  'admin.growth.atRiskRow': '{d} días activos · visto {hace}',

  // Servidor
  'admin.server.intro': 'La máquina, la API y la base de datos, medidas como lo hacen Datadog o Grafana (métodos USE y RED). En memoria: reiniciar el servicio borra la historia.',
  'admin.server.live': 'En vivo (15 s)',
  'admin.server.health': 'Chequeos de salud',
  'admin.check.db': 'Base de datos',
  'admin.check.db.help': 'PostgreSQL responde a un SELECT 1. Si falla, nadie puede entrar.',
  'admin.check.db.ok': 'Responde en {ms} ms',
  'admin.check.db.mal': '¡No responde!',
  'admin.check.disco': 'Disco',
  'admin.check.disco.help': 'Con menos de 2 GB libres no se acepta ninguna subida y PostgreSQL corre peligro.',
  'admin.check.disco.ok': '{libre} libres',
  'admin.check.disco.aviso': 'Solo {libre} libres: menos del 10 %',
  'admin.check.disco.mal': 'Solo {libre} libres: subidas bloqueadas',
  'admin.check.swap': 'Swap',
  'admin.check.swap.help': 'Con 1 GB de RAM, sin swap el backend muere por falta de memoria (DESPLIEGUE_AWS.md paso 4.1).',
  'admin.check.swap.ok': '{total} activa',
  'admin.check.swap.aviso': '¡Sin swap! Hazla permanente en /etc/fstab',
  'admin.check.ram': 'Memoria',
  'admin.check.ram.help': 'RAM en uso. Por encima del 90 % la máquina tira de swap y se pone lenta.',
  'admin.check.ram.ok': '{pct} % en uso',
  'admin.check.ram.aviso': '{pct} %: justa',
  'admin.check.ram.mal': '{pct} %: a punto de acabarse',
  'admin.check.cron_purga': 'Barrido de audios vencidos',
  'admin.check.cron_purga.help': 'El cron diario de purge_recordings.py (DESPLIEGUE_AWS.md paso 11.2) borra los audios caducados.',
  'admin.check.cron_purga.ok': 'Funcionando',
  'admin.check.cron_purga.aviso': '{n} audios vencidos siguen ahí: ¿corre el cron?',
  'admin.check.groq': 'Fuxi (Groq)',
  'admin.check.groq.help': 'Sin GROQ_API_KEY, Fuxi responde con el respaldo local de palabras clave.',
  'admin.check.groq.ok': 'Clave configurada',
  'admin.check.groq.aviso': 'Sin clave: solo respaldo local',
  'admin.check.correo': 'Correo (Brevo)',
  'admin.check.correo.help': 'Sin BREVO_API_KEY no salen los correos de recuperar contraseña.',
  'admin.check.correo.ok': 'Clave configurada',
  'admin.check.correo.aviso': 'Sin clave: no salen correos',
  'admin.check.monitor': 'Monitor de la máquina',
  'admin.check.monitor.help': 'Necesita el paquete psutil (requirements.txt).',
  'admin.check.monitor.ok': 'Midiendo cada minuto',
  'admin.check.monitor.aviso': 'Falta psutil: pip install -r requirements.txt',
  'admin.server.noPsutil': 'Sin datos de la máquina: instala psutil en el servidor (pip install -r requirements.txt) y reinicia el servicio.',
  'admin.server.cpuHelp': 'Uso medio de CPU en el último minuto.',
  'admin.server.cpuNote': '{n} núcleos · carga {carga}',
  'admin.server.steal': 'CPU robada',
  'admin.server.stealHelp': 'Tiempo de CPU que se lleva AWS. En una instancia t3 (burstable), steal alto = se acabaron los créditos de CPU y AWS está frenando la máquina.',
  'admin.server.stealOk': 'Créditos bien',
  'admin.server.stealBad': '¡Sin créditos de CPU!',
  'admin.server.ramHelp': 'Memoria en uso (sin la caché que se puede liberar).',
  'admin.server.swapHelp': 'Swap en uso. Swap subiendo = la RAM no alcanza.',
  'admin.server.noSwap': 'sin swap',
  'admin.server.diskFree': '{free} libres',
  'admin.server.process': 'Proceso de la API',
  'admin.server.processHelp': 'Memoria que usa uvicorn (el backend).',
  'admin.server.processNote': 'arriba {up} · {h} hilos',
  'admin.server.machine24': 'Máquina · últimas 24 h',
  'admin.server.warming': 'La gráfica de la máquina se llena con un punto por minuto: vuelve en un par de minutos.',
  'admin.server.machineNote': '{so} · Python {py} · máquina encendida hace {up}',
  'admin.server.api': 'API',
  'admin.server.rpm': 'Peticiones / min',
  'admin.server.rpmHelp': 'Tráfico (señal dorada 1): promedio de la última hora.',
  'admin.server.rpmNote': '{h} en 1 h · {d} en 24 h',
  'admin.server.errors': 'Errores 5xx (1 h)',
  'admin.server.errorsHelp': 'Errores (señal dorada 2): fallos del servidor. Los 4xx son equivocaciones del usuario (clave mal, sesión vencida) y son normales.',
  'admin.server.errorsNote': '24 h: {e5} errores 5xx · {e4} 4xx',
  'admin.server.p50Help': 'Latencia (señal dorada 3): la mitad de las peticiones va más rápido que esto.',
  'admin.server.p95Help': 'El 95 % de las peticiones va más rápido que esto. Lo que sienten los de mala suerte. Por encima de 1.5 s se nota.',
  'admin.server.p99Help': 'El 1 % más lento: picos, arranques en frío, subidas grandes.',
  'admin.server.since': 'API medida desde hace {up} (desde el último reinicio).',
  'admin.server.trafficHour': 'Tráfico · última hora',
  'admin.server.requests': 'Peticiones',
  'admin.server.latencyDay': 'Latencia media · 24 h',
  'admin.server.avgMs': 'Media',
  'admin.server.routes': 'Por ruta',
  'admin.server.routesHelp': 'Cada ruta de la API con sus peticiones, errores y latencia (últimas 300 llamadas). La más lenta es la primera a optimizar.',
  'admin.server.route': 'Ruta',
  'admin.server.max': 'Máx.',
  'admin.server.lastErrors': 'Últimos errores 500',
  'admin.server.journal': 'La traza completa: sudo journalctl -u audio -n 100 --no-pager',
  'admin.pg.ping': 'Latencia',
  'admin.pg.size': 'Tamaño',
  'admin.pg.up': 'Encendida hace',
  'admin.pg.connections': 'Conexiones',
  'admin.pg.cache': 'Aciertos de caché',
  'admin.pg.tx': 'Commits / rollbacks',
  'admin.pg.deadlocks': 'Interbloqueos',
  'admin.pg.tables': 'Tablas más grandes',
  'admin.pg.rows': '{n} filas',

  // Seguridad
  'admin.sec.failed': 'Entradas fallidas',
  'admin.sec.days7': 'últimos 7 días',
  'admin.sec.blocked': 'Bloqueos',
  'admin.sec.disabledTries': 'Intentos a cuentas desactivadas',
  'admin.sec.resets': 'Pedidos de recuperación',
  'admin.sec.pwChanged': '{n} contraseñas cambiadas',
  'admin.sec.adminActions': 'Acciones de admin',
  'admin.sec.chart24': 'Entradas · últimas 24 h',
  'admin.sec.ips': 'IPs que más fallan (7 d)',
  'admin.sec.ipsHelp': 'Una IP probando MUCHAS cuentas distintas = «password spraying». Clic para ver sus registros en la bitácora.',
  'admin.sec.emails': 'Cuentas más atacadas (7 d)',
  'admin.sec.emailsHelp': 'Una cuenta probada desde MUCHAS IPs = «credential stuffing» (una lista de claves robada de otro sitio).',
  'admin.sec.none': 'Nada sospechoso.',
  'admin.sec.tries': 'Intentos',
  'admin.sec.accounts': 'Cuentas',
  'admin.sec.last': 'Último',
  'admin.sec.spray': 'spraying',
  'admin.sec.sprayHelp': 'Esta IP probó 3 cuentas distintas o más',
  'admin.sec.locks': '{n} bloqueos',
  'admin.sec.ghost': 'no existe',
  'admin.sec.stuffing': 'stuffing',
  'admin.sec.stuffingHelp': 'Probada desde 3 IPs distintas o más',
  'admin.sec.newIp': 'Entradas desde una IP nueva (7 d)',
  'admin.sec.newIpHelp': 'Entradas correctas desde una IP que esa cuenta no usó en los 30 días anteriores (GitHub avisa de esto). Suele ser un celular o una red nueva; si la persona no fue, cierra todas sus sesiones.',
  'admin.sec.admins': 'Revisión de accesos de admin',
  'admin.sec.adminsHelp': 'Quién tiene las llaves. Las auditorías piden revisarlo cada cierto tiempo: un admin que ya no lo necesita debería dejar de serlo.',
  'admin.sec.adminRow': 'visto {hace} · {n} acciones (30 d)',

  // Avisos
  'admin.ann.title': 'Aviso para todos',
  'admin.ann.help': 'Una pastilla abajo en todas las páginas, también en la de entrar. Para mantenimientos, novedades o incidentes. Cada usuario puede cerrarlo; publicar uno nuevo lo vuelve a mostrar.',
  'admin.ann.showing': 'Se ve ahora',
  'admin.ann.hidden': 'No se ve',
  'admin.ann.tone': 'Tipo',
  'admin.ann.tone.info': 'Información',
  'admin.ann.tone.aviso': 'Advertencia',
  'admin.ann.tone.mantenimiento': 'Mantenimiento',
  'admin.ann.textEs': 'Texto en español',
  'admin.ann.textEn': 'Texto en inglés',
  'admin.ann.from': 'Mostrar desde (opcional)',
  'admin.ann.until': 'Hasta (opcional)',
  'admin.ann.datesHelp': 'En tu hora local. Sin fechas se ve hasta que lo quites.',
  'admin.ann.publish': 'Publicar',
  'admin.ann.remove': 'Quitar',
  'admin.ann.live': 'Publicado: todos lo ven ya.',
  'admin.ann.scheduled': 'Guardado: saldrá dentro de sus fechas.',
  'admin.ann.off': 'Aviso quitado.',
  'admin.ann.by': 'Último cambio: {who} · {when}',
  'admin.ann.preview': 'Vista previa',
  'admin.ann.previewHelp': 'Así se ve (en el idioma actual).',
  'admin.ann.empty': 'Escribe el texto…',
  'admin.ann.close': 'Cerrar el aviso',
};

const admin = { en, es };
export default admin;
